import { useTheme } from "components/common/hooks/useTheme/useTheme";
import { Analytics } from "lib/analytics/analytics";
import { Route } from "lib/routes";

type AddReviewMenuLinkItemBase = {
  label: string;
};

export type AddReviewMenuLinkItem = AddReviewMenuLinkItemBase & {
  link: Route;
};

// to support actions including dark mode toggle
export type AddReviewMenuActionItem = AddReviewMenuLinkItemBase & {
  action: () => void;
};

export type AddReviewMenuItem = AddReviewMenuLinkItem | AddReviewMenuActionItem;

export type AddReviewMenuColumn = {
  title: string;
  items: AddReviewMenuItem[];
};

export const useAddReviewMenuColumns = (): AddReviewMenuColumn[] => {
  const { mode, toggleMode } = useTheme();

  const handleToggleMode = () => {
    toggleMode();
    Analytics.themeSwitched({
      newTheme: mode === "light" ? "dark" : "light",
      themeToggleLocation: "addReviewMenu",
    });
    window.location.reload();
  };

  return [
    {
      title: "Add",
      items: [
        {
          label: "Transaction",
          link: Route.transactions,
        }, // todo: RED-1787: make open create form
        {
          label: "Journal entry",
          link: Route.newManualJournal,
        },
        {
          label: "Invoice",
          link: Route.newInvoice,
        },
        {
          label: "Bill",
          link: Route.newBill,
        },
        {
          label: "Classes & departments",
          link: Route.classesSettings,
        }, // todo: RED-1787: make open create form
        {
          label: "Accounting policy",
          link: Route.newPolicy,
        },
        {
          label: "Integration",
          link: Route.integrations,
        }, // todo: RED-1787: make open create form
        {
          label: "Chart of accounts",
          link: Route.chartOfAccounts,
        }, // TODO: confirm
        {
          label: "Users",
          link: Route.usersSettings,
        }, // TODO: confirm
      ],
    },
    {
      title: "Review",
      items: [
        {
          label: "Transactions",
          link: Route.transactions,
        },
        {
          label: "Transaction rules",
          link: Route.rules,
        },
        {
          label: "Customer payments",
          link: Route.newInvoicePayment,
        },
        {
          label: "AR aging",
          link: Route.arAging,
        },
        {
          label: "AP aging",
          link: Route.apAging,
        },
        {
          label: "Prepaids",
          link: Route.prepaidExpenses,
        },
        {
          label: "Fixed assets",
          link: Route.fixedAssets,
        },
        {
          label: "Revenue recognition",
          link: Route.revenueRecognition,
        },
        {
          label: "General ledger",
          link: Route.generalLedger,
        },
        {
          label: "Financial statements",
          link: Route.reports,
        },
      ],
    },
    {
      title: "Settings",
      items: [
        {
          label: "Accounting policies",
          link: Route.policySettings,
        },
        {
          label: "AI & automation",
          link: Route.automationSettings,
        },
        {
          label: "Users",
          link: Route.usersSettings,
        },
        {
          label: "Company settings",
          link: Route.companySettings,
        },
        {
          label: `Switch to ${mode === "light" ? "dark" : "light"} mode`,
          action: handleToggleMode,
        },
      ],
    },
  ];
};
